import React from "react";

export const NavigationDots = ({ total, current, onNavigate }) => {
  return (
    <nav className="pres-dots" aria-label="Slide navigation">
      {Array.from({ length: total }).map((_, i) => (
        <button
          key={i}
          className={`pres-dot ${i === current ? "pres-dot-active" : ""} ${i < current ? "pres-dot-passed" : ""}`}
          onClick={() => onNavigate(i)}
          aria-label={`Go to slide ${i + 1}`}
          aria-current={i === current ? "step" : undefined}
        >
          <span className="pres-dot-inner" />
        </button>
      ))}
    </nav>
  );
};
